import React from "react";
import FormatMoney from "go-core/components/Formatters/FormatMoney";

interface Props {
	title: string;
	value: number;
	asMoney?: boolean;
	potentialValue: number;
	percentValue: number;
	currency: string;
}

const OrganizationProductCategoryChartItem = ({
	value,
	title,
	potentialValue,
	percentValue,
	asMoney,
	currency,
}: Props) => {
	const getBarBackgroundWidth = () => {
		if (percentValue > 100) return "100%";
		return `${percentValue}%`;
	};

	const getValueTitle = () => {
		const valueToDisplay = asMoney ? FormatMoney({ amount: value, currency }) : value;
		const potentialValueToDisplay = asMoney ? FormatMoney({ amount: potentialValue, currency }) : potentialValue;

		return `${valueToDisplay}/${potentialValueToDisplay}`;
	};

	return (
		<div className="d-flex flex-column organization-product-category-chart-item">
			<div className="d-flex align-items-center justify-content-between">
				<p className="mb-0 text-muted">{title}</p>
				<h6 className="mb-0">{getValueTitle()}</h6>
			</div>
			<div className="d-flex align-items-center justify-content-between gap-2">
				<div className="organization-product-chart-bar">
					<div
						className="organization-product-chart-bar-background"
						style={{ width: getBarBackgroundWidth() }}
					/>
				</div>
				<p className="mb-0 font-weight-bold percent-value">{`${percentValue}%`}</p>
			</div>
		</div>
	);
};

export default OrganizationProductCategoryChartItem;
